import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore"
import {getAuth,GoogleAuthProvider } from "firebase/auth";
import {getStorage} from "firebase/storage"
const firebaseConfig = {
  apiKey: "AIzaSyCjeWw38Bz3twHAiqEgRy2el_5cHRq7kk0",
  authDomain: "voguishtrendy.firebaseapp.com",
  projectId: "voguishtrendy",
  storageBucket: "voguishtrendy.firebasestorage.app",
  messagingSenderId: "700168238343",
  appId: "1:700168238343:web:f3944ac32250b2800841a2"
};
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();